import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type RootState } from '../../../../app/store'

export interface EditSolarPlantState {
  page: number
  showInactiveSolarPlants: boolean
  currentSolarProjectId: number | null
  tabIndex: number
  // overrideLockedFields: boolean
}

const initialState: EditSolarPlantState = {
  page: 0,
  showInactiveSolarPlants: false,
  currentSolarProjectId: null,
  tabIndex: 0
  // overrideLockedFields: false
}

export const editSolarPlantSlice = createSlice({
  name: 'editSolarPlant',
  initialState,
  reducers: {
    setSolarPlantListPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload
    },
    setShowInactivePlants: (state, action: PayloadAction<boolean>) => {
      state.showInactiveSolarPlants = action.payload
    },
    setCurrentSolarProjectId: (state, action: PayloadAction<number | null>) => {
      state.currentSolarProjectId = action.payload
    },
    setSolarPlantTabIndex: (state, action: PayloadAction<number>) => {
      state.tabIndex = action.payload
    },
    // setSolarPlantOverrideLockedFields: (state, action: PayloadAction<boolean>) => {
    //   state.overrideLockedFields = action.payload
    // },
    resetEditSolarPlant: (state) => {
      state.currentSolarProjectId = null
      state.tabIndex = 0
      // state.overrideLockedFields = false
    }
  }
})

export const {
  setSolarPlantListPage,
  setShowInactivePlants,
  setCurrentSolarProjectId,
  setSolarPlantTabIndex,
  // setSolarPlantOverrideLockedFields,
  resetEditSolarPlant
} = editSolarPlantSlice.actions

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectSolarPlantListPage = (state: RootState): number => state.editSolarPlant.page
export const selectShowInactivePlants = (state: RootState): boolean => state.editSolarPlant.showInactiveSolarPlants
export const selectCurrentSolarProjectId = (state: RootState): number | null => state.editSolarPlant.currentSolarProjectId
export const selectSolarPlantTabIndex = (state: RootState): number => state.editSolarPlant.tabIndex
// export const selectSolarPlantOverrideLockedFields = (state: RootState): boolean => state.editSolarPlant.overrideLockedFields

export default editSolarPlantSlice.reducer
